<mat-label *ngIf="!labelInside">Environment</mat-label>
<mat-form-field class="environment-field" floatLabel="always">
  <mat-label *ngIf="labelInside">Environment</mat-label>
  <mat-select xpoSelect [formControl]="control">
    <mat-option *ngFor="let env of environments | keyvalue" [value]="env.value">
      {{ env.value }}
    </mat-option>
  </mat-select>
</mat-form-field>
